<h2 *ngIf="this.data.isDelivery && !data.hmsField" mat-dialog-title>Landing Date</h2>
<h2 *ngIf="this.data.isDelivery && data.hmsField == 'arrivalDate'" mat-dialog-title>Arrival Date</h2>
<h2 *ngIf="this.data.isDelivery && data.hmsField == 'departureDate'" mat-dialog-title>Departure Date</h2>
<h2 *ngIf="this.data.isUnloading" mat-dialog-title> Unloading Date</h2>
<h2 *ngIf="this.data.isHMS" mat-dialog-title>Fishing Date</h2>
<h2 *ngIf="!this.data.isDelivery && this.data.isStart" mat-dialog-title> Start Date</h2>
<h2 *ngIf="!this.data.isDelivery && this.data.isEnd" mat-dialog-title> End Date</h2>

<mat-dialog-content>
  <div class="container" style="display: flex; flex-direction: column; height: 100%;" (keyup.enter)="onConfirm()">

    <!-- Calendar Section -->
    <div class="row">
      <mat-card class="demo-inline-calendar-card">
        <mat-calendar
          [maxDate]="data.isDelivery || data.isUnloading ? null : maxDate"
          [minDate]="data.isDelivery && data.hmsField === 'arrivalDate' ? data.minDate : null"
          [(selected)]="selectedDate"
          (selectedChange)="onCalendarDateSelected($event)">
        </mat-calendar>
      </mat-card>
      
    </div>

    <!-- Time Picker and Date Fields Container -->
    <div class="time-date-container" *ngIf="this.data.isStart || this.data.isEnd">
      <!-- Date Fields -->
      <div class="date-fields" style="gap: 8px;">
        <form [formGroup]="formFields">
          <mat-form-field appearance="fill" class="date-field">
            <mat-label>DD</mat-label>
            <input matInput formControlName="day" type="text"
                   maxlength="2"
                   (input)="_forbidNonNumeric(formFields.get('day')!)">
                   <mat-error *ngIf="formFields.get('day')?.hasError('max')"></mat-error>
          </mat-form-field>
          
          <mat-form-field appearance="fill" class="date-field">
            <mat-label>MM</mat-label>
            <input matInput formControlName="month" type="text"
                   maxlength="2"
                   (input)="_forbidNonNumeric(formFields.get('month')!)">
                   <mat-error *ngIf="formFields.get('month')?.hasError('max')"></mat-error>
          </mat-form-field>
          
          <mat-form-field appearance="fill" class="date-field" style="width: 90px;">
            <mat-label>YYYY</mat-label>
            <input matInput formControlName="year" type="text"
                   maxlength="4"
                   (input)="_forbidNonNumeric(formFields.get('year')!)">
                   <mat-error *ngIf="formFields.get('year')?.hasError('max')"></mat-error>
          </mat-form-field>
        </form>
        
        
      </div>
      <div *ngIf="!data.isDelivery" class="time-picker">
        <ngb-timepicker [meridian]="false" [(ngModel)]="selectedTime"></ngb-timepicker>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button
          class="text-button"
          type="submit"
          (click)="onConfirm()">
    OK
  </button>
</mat-dialog-actions>
